// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2yrq9","detailsBorder":"styles_detailsBorder__zdLXW"};